import {RouterLink} from "@angular/router";
import {LngRoutePipe} from "@app/shared/pipes";
import {TranslatePipe} from "@ngx-translate/core";
import {AppStateService} from "@app/shared/services/app-state.service";
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';

@Component({
  selector: 'sf-resume-examples-banner',
  templateUrl: './resume-examples-banner.component.html',
  styleUrl: './resume-examples-banner.component.scss',
  imports: [
    RouterLink,
    TranslatePipe,
    LngRoutePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResumeExamplesBannerComponent {
  protected readonly appStateService = inject(AppStateService);
}
